import { useAuth } from '@/context/auth-context';
import { useQuery } from '@tanstack/react-query';
import { invokeEdgeFunction } from '@/lib/supabase-functions-wrapper';
import { CompanyType } from '@/types/enums';
import { componentLogger } from '@/lib/logging';



/**
 * Hook to check if the current user belongs to a CLIENT type company
 * @returns {boolean} true if user belongs to a CLIENT company, false otherwise
 */
export const useIsClientCompany = () => {
  const { user } = useAuth();

  const { data: userCompanyData, isLoading, error: _error } = useQuery({
    queryKey: ['userCompanyInfo', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      const { data, error } = await invokeEdgeFunction('get-user-company-info');
      
      if (error) {
        componentLogger.error('Failed operation:', (error as Error).message, { context: 'useIsClientCompany', error });
        return null;
      }
      
      return data;
    },
    enabled: !!user?.id,
  });

  const company = (userCompanyData as unknown as { company?: unknown })?.company;

  return {
    isClientCompany: (company as unknown as { type?: unknown })?.type === CompanyType.CLIENT,
    company,
    isLoading: isLoading || ((userCompanyData as unknown as { user?: { company_id?: unknown } })?.user?.company_id && !company),
  };
};